import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetListRequest, GetPlayerListResponse } from '../type/types';

// 플레이어 목록 조회
export const getPlayerList = async (params: GetListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetPlayerListResponse>>(
    `/api/web/admins/players`,
    { params: query }
  );
  return res.data;
};
